import React from "react";
import { useState, useRef, useEffect } from "react";
import { Alert, Form, Button } from "react-bootstrap";
import { GET } from "../../Database/RealtimeDatabase";
import { getDatabase, ref, child, update, push } from "firebase/database";
import { useHistory } from "react-router-dom";

import SelectSearch from "react-select-search";
import "react-select-search/style.css";

import Section from "../../UI/Section/Section";
import AdminTabs from "../AdminTabs/AdminTabs";

export default function NewContract() {
  const termsRef = useRef();
  const priceRef = useRef();
  const perkRef = useRef();
  const skilRef = useRef();
  const userRef = useRef();//keep it for live sync
  const [selectedUser, setSelectedUser] = useState(null);
  const isCompletedRef = useRef(false);
  const [submitting, setSubmitting] = useState(false);
  const [dateNow, setNow] = useState(new Date());
  const [perks, setPerks] = useState([]);
  const [skills, setSkills] = useState([]);
  const [users, setUsers] = useState([]);
  const [alert, setAlert] = useState();

  //TODO оптимизировать:
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingPerks, setLoadingPerks] = useState(false);
  const [loadingSkills, setLoadingSkills] = useState(false);

  const history = useHistory();

  // Отправить Новый контракт
  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    const newContract = {
      party: userRef.current.value,
      rewardPrice: priceRef.current.value,
      rewardperk: perkRef.current.value,
      rewardskil: skilRef.current.value,
      terms: termsRef.current.value,
      dateOpen: dateNow.getTime(),
      dateUpdated: dateNow.getTime(),
      //статус: если контракт не заверщен при создании, то, если назначен юзер, ставим статус - в работе
      status: isCompletedRef.current.checked ? 2 : userRef.current.value ? 1 : 0,
    };

    const db = getDatabase();
    const newPostKey = push(child(ref(db), "posts")).key;
    const updates = {};
    updates["/contracts/" + newPostKey] = newContract;
    update(ref(db), updates)
      .then(() => {
        history.replace("/contracts");
      })
      .catch((error) => {
        setAlert({ variant: "danger", msg: error.message });
        setSubmitting(false);
      });
  }

  useEffect(() => {
    //Load Perks
    setLoadingPerks(true);
    GET("perks").then((items) => {
      setLoadingPerks(false);
      setPerks(items);
    });

    //Load Skills
    setLoadingSkills(true);
    GET("skills").then((items) => {
      setLoadingSkills(false);
      setSkills(items);
    });

    //Load Users
    setLoadingUsers(true);
    GET("users").then((items) => {
      setLoadingUsers(false);
      setUsers(items);
    });
  }, []);

  if (loadingPerks || loadingSkills || loadingUsers)
    return <p>Загружаем каталоги</p>;

  return (
    <>
      <Section>
        <AdminTabs />
      </Section>
      <Section>
        <h2>Новый контракт</h2>
        {dateNow.toLocaleString()}
        {alert && (
          <Alert variant={alert.variant ? alert.variant : "success"}>
            {alert.msg}
          </Alert>
        )}
        <Form onSubmit={handleSubmit}>
          <Form.Group id="terms">
            <Form.Label>Суть задачи/достижения</Form.Label>
            <Form.Control type="text" ref={termsRef} required />
          </Form.Group>
          <Form.Group id="price">
            <Form.Label>Стоимость</Form.Label>
            <Form.Control type="number" ref={priceRef} />
          </Form.Group>
          <Form.Group id="perk">
            <Form.Label>Ачивка</Form.Label>
            <Form.Select ref={perkRef}>
              <option value="" key="none">
                Нет
              </option>
              {perks &&
                perks.map((perk) => (
                  <option key={perk.id} value={perk.id}>
                    {perk.name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>
          <Form.Group id="skill">
            <Form.Label>Скил</Form.Label>
            <Form.Select ref={skilRef}>
              <option value="" key="none">
                Нет
              </option>
              {skills &&
                skills.map((skill) => (
                  <option key={skill.id} value={skill.id}>
                    {skill.name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>

          <Form.Group id="user">
            <Form.Label>Ответственный</Form.Label>
            <SelectSearch
              search={true}
              autoComplete={true}
              onChange={setSelectedUser}
              value={selectedUser}
              placeholder="Не назначать"
              options={users.map((user) => ({
                value: user.id,
                name: user.name,
              }))}
            />
            <input type="hidden" ref={userRef} value={selectedUser} />
          </Form.Group>

          <Form.Group id="completed">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="isCompletedCheckbox"
                ref={isCompletedRef}
              />
              <label class="form-check-label" for="isCompletedCheckbox">
                Сразу выдать награды и закрыть задачу
              </label>
            </div>
          </Form.Group>

          <Button disabled={submitting} className="w-100 mt-3" type="submit">
            Добавить
          </Button>
        </Form>
      </Section>
    </>
  );
}
